<template>
  <div class="big-row">
    <div class="big-screen-title">
      <div class="title-row">
        <img :src="imgSrc" class="title-icon" v-if="imgSrc"/>
        <div class="title">{{title}}</div>
      </div>
      <div class="vice-title" v-if="viceTitle" @click="viceTitleClick">{{viceTitle}}</div>
    </div>
    <div class="content-body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    title: {
      require: true,
      type: String
    },
    viceTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    viceTitleClick () {
      this.$emit('viceTitleClick')
    }
  }
}
</script>
<style lang="scss" scoped>
.big-row {
  .big-screen-title {
    position: relative;
    z-index: 10;
    border: 1px solid #13B4E6;
    border-image: linear-gradient(90deg, #00afed 0%, #1C789D 70%, rgba(0, 216, 247, 0) 100%) 2 2 2 2;
    border-right: 0;
    background: linear-gradient(to right, #152B45 0%, #1A314F 30%, #213956 60%, rgba(43, 68, 98, 0.8) 80%, rgba(43,68,98,0.6) 90%, rgba(43,68,98,0.3) 96%,  rgba(43,68,98,0) 100%);
    border-top-right-radius: 0.1rem;
    border-bottom-right-radius: 0.1rem;
    border-right: 0;
    padding: 0.05rem;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &::before {
      z-index: -1;
      border: 1px solid #13B4E6;
      border-image: linear-gradient(90deg, #13B4E6 0%, #13B4E6 70%, rgba(0, 216, 247, 0) 100%) 2 2 2 2;
      right: 0.05rem;
      top: 0.05rem;
      position: absolute;
      left: -0.06rem;
      bottom: -0.06rem;
      content: ' ';
      opacity: 0.4;
    }
    .title-row {
      display: flex;
      .title-icon {
        width: 0.25rem;
        margin-right: 0.05rem;
      }
      .title {
        background-image: linear-gradient(to bottom, #FFFFFF, #A8C6E1);
        -webkit-background-clip: text;
        color: transparent;
        font-size: 0.2rem;
      }
    }
    .vice-title {
      padding-right: 0.2rem;
      color: #9DD1FF;
    }
  }
  .content-body {
    position: relative;
    padding: 0.2rem 0;
    box-sizing: border-box;
    height: 100%;
    // height: calc(100% - 0.5rem);
    overflow: scroll;
    scrollbar-width: none;
    &::-webkit-scrollbar {
     width: 0 !important;
    }
}
}

</style>
